import styled from "@emotion/styled";
import Dialog, { dialogClasses } from "@mui/material/Dialog";
import { paperClasses } from "@mui/material/Paper";
import { dialogContentClasses, linearProgressClasses, mobileStepperClasses } from "@mui/material";

export const Header = styled.div({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	padding: "8px 0px 16px 0px"
});

export const SubTitle = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.palette.text.secondary
}));

export const CatalogsContainer = styled.div(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "column"
}));

export const CurrentCatalog = styled.div(({ theme }) => ({
	borderBottom: `1px solid ${theme.palette.divider}`,
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	padding: "8px 16px"
}));

export const Content = styled.div({
	display: "flex",
	flexDirection: "column",
	padding: "0px 24px 24px 24px",
	gap: 16
});

export const Description = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary
}));

export const CatalogContainer = styled.div({
	display: "flex",
	flexDirection: "column"
});

export const DropdownContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	minHeight: "360px",
	[theme.breakpoints.down("sm")]: {
		minHeight: "460px"
	}
}));

export const CatalogContainerTitle = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const CatalogContainerText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
	[`& > .${dialogClasses.container} > .${paperClasses.root}`]: {
		minHeight: 662,
		minWidth: 600,
		paddingBottom: "16px",
		form: {
			display: "flex",
			flexDirection: "column",
			flex: 1
		},
		h2: {
			paddingBottom: 8
		},
		[`.${dialogContentClasses.root}`]: {
			padding: "16px 24px"
		},
		[`.${mobileStepperClasses.root}`]: {
			padding: "8px 24px"
		},
		[theme.breakpoints.down("md")]: {
			height: 500,
			minWidth: 375,
			h2: {
				alignItems: "flex-start",
				"button:first-of-type": {
					padding: "4px 0px"
				}
			}
		}
	},
	[theme.breakpoints.down("sm")]: {
		[`& > .${dialogClasses.container} > .${paperClasses.root}`]: {
			minHeight: 810
		}
	}
}));

export const LoadingContainer = styled.div(({ theme }) => ({
	minHeight: "360px",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	padding: "16px",
	[`& .${linearProgressClasses.bar}`]: {
		backgroundColor: theme.project.colors.allColors.hex.blue.cwg.cwgBlue900
	},
	[`& .${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: `rgba(${theme.project.colors.allColors.hex.blue.cwg.cwgBlue900}, 0.5)`
	}
}));

export const LoadingText = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.palette.text.primary,
	marginBottom: 24,
	textAlign: "center"
}));
